import { useEffect, useState } from "react";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";

import actions from "../../../data/actions";

const AfterFooter = props => {
  const theme = useTheme();

  const bgcolor = theme.palette.primary.main;
  const color = theme.palette.text.primary;

  return (
    <>
      <Paper elevation={0} square sx={{ bgcolor, color }}>
        <Container disableGutters maxWidth="lg">
          <Box sx={{ alignItems: "center", display: "flex", justifyContent: "center", px: 2, py: 0.5 }}>
            <Typography component="div" variant="body2">
              {"©2022 MesterVet. Szolgáltató: DiMa.hu Kft."}
            </Typography>
          </Box>
        </Container>
      </Paper>
    </>
  );
};

export default AfterFooter;
